'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = init;
/** @param {{
 *  el: HTMLElement
 *  context: {
 *    className: string
 *    getElement: (selector: string) => HTMLElement
 *    getElements: (selector: string) => HTMLElement[]
 *  }
 * }} options
 */
function init(_ref) {
  var el = _ref.el,
      context = _ref.context;

  var elements = {
    container: el,
    listItems: context.getElements('[data-el="reveal-list.item"]'),
    toggle: context.getElement('[data-el="reveal-list.toggle"]')
  };

  function reveal() {
    elements.listItems.forEach(function (listItem) {
      listItem.dataset.state = 'visible';
    });

    elements.container.dataset.state = 'expanded';
  }

  elements.toggle.addEventListener('click', reveal);
}